var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSkill5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61 63",
    style: {
      enableBackground: "new 0 0 61 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000101801802591740796040000002381289937555427773_);}\r\n\t.st2{fill:url(#SVGID_00000111193472067018190690000013892268745425257125_);}\r\n\t.st3{fill:url(#SVGID_00000052071523458729366420000007019024678614654347_);}\r\n\t.st4{fill:url(#SVGID_00000115500399620061490970000016955737916504181934_);}\r\n\t.st5{fill:url(#SVGID_00000114760373552562186130000013658671441850679985_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.9751,
    y1: 22.0212,
    x2: 60.0044,
    y2: 22.0212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,27.5c3,0,5.5-2.5,5.5-5.5s-2.5-5.5-5.5-5.5S49,19,49,22S51.4,27.5,54.5,27.5z M54.5,19.5 c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5S52,23.4,52,22S53.1,19.5,54.5,19.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160163559827156570540000004761756073778239164_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.7749,
    y1: 7.2878,
    x2: 46.8052,
    y2: 7.2878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160163559827156570540000004761756073778239164_)"
    },
    d: "M41.3,12.8c3,0,5.5-2.5,5.5-5.5 s-2.5-5.5-5.5-5.5s-5.5,2.5-5.5,5.5S38.2,12.8,41.3,12.8z M41.3,4.8c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5 S39.9,4.8,41.3,4.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114758756651477726100000009920335370150578600_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.9331,
    y1: 16.7683,
    x2: 13.9634,
    y2: 16.7683
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114758756651477726100000009920335370150578600_)"
    },
    d: "M8.4,22.3c3,0,5.5-2.5,5.5-5.5 s-2.5-5.5-5.5-5.5s-5.5,2.5-5.5,5.5S5.4,22.3,8.4,22.3z M8.4,14.3c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5 S7.1,14.3,8.4,14.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011750426044009605950000005295813047747517579_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.771,
    y1: 5.8757,
    x2: 28.8013,
    y2: 5.8757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011750426044009605950000005295813047747517579_)"
    },
    d: "M23.3,11.4c3,0,5.5-2.5,5.5-5.5 s-2.5-5.5-5.5-5.5s-5.5,2.5-5.5,5.5S20.2,11.4,23.3,11.4z M23.3,3.4c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5 S21.9,3.4,23.3,3.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109745616184164821290000003057809663684424623_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.2446,
    y1: 30.6541,
    x2: 41.7573,
    y2: 30.6541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109745616184164821290000003057809663684424623_)"
    },
    d: "M18.2,30.7c0,6.5,5.3,11.8,11.8,11.8 s11.8-5.3,11.8-11.8S36.5,18.9,30,18.9S18.2,24.2,18.2,30.7z M30,21.9c4.8,0,8.8,3.9,8.8,8.8s-3.9,8.8-8.8,8.8s-8.8-3.9-8.8-8.8 S25.2,21.9,30,21.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137106537722165753550000017337878495894785693_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4414,
    y1: 47.8095,
    x2: 60.5586,
    y2: 47.8095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137106537722165753550000017337878495894785693_)"
    },
    d: "M59.2,33.9c-1.2-0.9-2.9-1.1-4.6-0.5 c-1.2,0.5-2.9,2.1-5.8,5c-2.8,2.7-6.2,6.1-8.3,7.2c-3.9,1.9-7,2-9.9,2.2c-3-0.1-6-0.3-9.9-2.2c-2.2-1-5.6-4.4-8.3-7.2 c-2.9-2.9-4.6-4.6-5.9-5c-1.6-0.6-3.4-0.4-4.6,0.5c-1.1,0.9-1.6,2.2-1.3,3.8c0.4,2.8,4.2,11.7,17,20.1l0.2,4.9l3-0.1L20.4,56 l-0.7-0.4c-12.5-8-16-16.5-16.3-18.4c-0.1-0.5,0-0.8,0.2-1C4,36,4.6,35.9,5.3,36.1c0.7,0.3,3.1,2.6,4.8,4.3c3.1,3,6.5,6.5,9.1,7.7 c4.2,2,7.5,2.3,10.5,2.4l0,0.1l0.7,0c0,0,0,0,0,0c0,0,0,0,0,0l0.7,0l0-0.1c3-0.1,6.3-0.4,10.5-2.4c2.6-1.3,6.1-4.7,9.1-7.7 c1.7-1.7,4.1-4.1,4.8-4.3c0.7-0.3,1.3-0.2,1.6,0.1c0.2,0.2,0.3,0.5,0.2,1c-0.3,1.9-3.8,10.4-16.3,18.4L40.6,56l-0.3,6.5l3,0.1 l0.2-4.9c12.8-8.4,16.6-17.3,17-20.1C60.7,36.1,60.2,34.7,59.2,33.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkill5);
export default __webpack_public_path__ + "static/media/icon_skill5.03c8b19b0504ae3cdaa61794fcb5c30f.svg";
export { ForwardRef as ReactComponent };